import { useTheme } from '@/contexts/ThemeContext';
import { getThemeImages, type ThemeImageSet } from '@/assets/themeImages';

export function useThemeImages(): ThemeImageSet {
  const { theme } = useTheme();
  return getThemeImages(theme);
}
